/* eslint-disable class-methods-use-this */
import logger from '../logger';
import publicEnv from '../publicEnv';
const { GA_TRACKING_ID } = publicEnv;

let ua = null;
let visitor = null;

if (typeof window === 'undefined') {
  // logger.debug('trackers: constructor');
  ua = require('universal-analytics'); // eslint-disable-line global-require
  visitor = ua(GA_TRACKING_ID);
}

if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
  gtag('set', {
    transport_type: 'beacon',
  });
}

/*
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
class Track {
  constructor() {
    this.timeEvents = {};
    this.event = this.event.bind(this);
    this.pageview = this.pageview.bind(this);
    this.screenview = this.screenview.bind(this);
    this.set = this.set.bind(this);
    this.time = this.time.bind(this);
    this.startTime = this.startTime.bind(this);
    this.endTime = this.endTime.bind(this);
  }

  // Category and action are required
  // example: track.event('notes', 'open_note_document', {label: '', value, '', options})
  event(category, action, config = {}) {
    const {
      label = null,
      value = null,
      options = {},
    } = config;
    if (typeof window === 'undefined') {
      const serverEventDetails = {
        eventCategory: category,
        eventAction: action,
      };

      if (label) {
        serverEventDetails.eventLabel = label;
      }

      if (value) {
        serverEventDetails.eventValue = value;
      }
      visitor.event(serverEventDetails).send();
    }

    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      const clientEventDetails = {
        event_category: category,
      };

      if (label) {
        clientEventDetails.event_label = label;
      }

      if (value) {
        clientEventDetails.value = value;
      }

      // logger.debug(`tracker: event gtag('event', action, clientEventDetails)`); // eslint-disable-line quotes
      // Send using Google Tag Manager
      const eventOptions = Object.assign({}, clientEventDetails, options);
      gtag('event', action, eventOptions);
    }
  }

  /*
   * https://developers.google.com/analytics/devguides/collection/gtagjs/pages
   * Example:
   * track.pageview({
     page_title: '', // The page's title.
     page_location: '', // The page's URL.
     page_path: '', // The path portion of location. This value must start with a slash (/)
   })
   */
  pageview(pageObject) {
    const {
      pagePath,
      pageLocation,
      pageTitle,
    } = pageObject;

    if (typeof window === 'undefined') {
      visitor.pageview(pagePath, pageLocation, pageTitle).send();
    }

    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      gtag('config', `'${GA_TRACKING_ID}'`, {
        page_path: pagePath,
        page_location: pageLocation,
        page_title: pageTitle,
      });
    }
  }

  /*
   * Example:
   * track.screenview('main');
   */
  screenview(screen) {
    const appName = 'drynotes_webapp';

    if (typeof window === 'undefined') {
      visitor.screenview(screen, appName).send();
    }

    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      gtag('event', 'screen_view', {
        app_name: appName,
        screen_name: screen,
      });
    }
  }

  set(key, value) {
    if (typeof window === 'undefined') {
      visitor.set(key, value);
    }

    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      const options = {
        [key]: value,
      };

      gtag('set', options);
    }
  }

  //  gtag('event', 'timing_complete', {
  //   'name' : 'load',
  //   'value' : 3549,
  //   'event_category' : 'JS Dependencies'
  // });
  time(options) {
    const {
      category = null,
      value = null,
      name = null,
      label = null,
    } = options;

    if (typeof window === 'undefined') {
      visitor.timing(category, name, value, label).send();
    }

    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      const clientOptions = {
        event_category: category,
        name,
        value,
      };

      if (label) {
        clientOptions.event_label = label;
      }
      gtag('event', 'timing_complete', clientOptions);
    }
  }

  /**
   * Starts a tracked time event
   * @param {String} timeName
   * @returns {void}
   * @example
   * // track.startTime('fetchNotes');
   */
  startTime(timeName) {
    this.timeEvents[timeName] = new Date();
  }
  
  /**
   * Completes a tracked time event
   * @param {String} timeName
   * @returns {number} completedTime
   * @example
   * // const eventTime = track.endTime('fetchNotes');
   */
  endTime(timeName) {
    const endTime = new Date();
    const completedTime = (endTime.getTime() - this.timeEvents[timeName].getTime());

    // Delete the timeName event
    delete this.timeEvents[timeName];

    // Return back the completed time
    return completedTime;
  }

  /*
   * Track exceptions to measure the number and type of crashes or errors that occur on a web page.
   * Set to true if the error is fatal
   * Example:
   * track.exception('my message', false);
   */
  exception(message, isfatal = false) {
    if (typeof window === 'undefined') {
      visitor.exception(message, isfatal).send();
    }

    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      gtag('event', 'exception', {
        description: message,
        fatal: isfatal,
      });
    }
  }
}

// [X] const time = (object) category, variable, time in ms, label
// [X] const pageview = (string)
// [X] const screenview = (string)
// [x] const exception = (string, isfatal boolean)
// const transaction = () // future thinking
// [X] const set = (key, value)

const trackers = new Track();
export default trackers;

